
import { authTokenService } from '@/services/authTokenService.js';
import { CONSTANTS } from '../../../common/constants';
import { answerService } from '../../../services/answerService';
import { surveyService } from '../../../services/surveyService';
import { utilityService } from '../../../services/utilityService';
import { configService } from '@/services/configService';

export const questionMixins = {
	data: () => ({
		isHelpDisplayed: false,
		isErrorsOverlayDisplayed: false,
		x: '',
		section: null,
		columns: null,
		columnHeader: null,
		answersMatrix: null,
		answerLayout: null,
    loading: false,
    hasExp: null
	}),
	computed: {
		myAnswer: function () {
			return this.answer;
		},
		myColumns: function () {
			return this.columns;
		},
		myMatrix: function () {
			return this.answersMatrix;
		},
		mySection: function () {
			return this.section;
		},
		answer: function () {
			return this.$store.getters['answersArray'][this.qId];
		},
		count: function () {
			return this.$store.getters['count'];
		}
	},
	mounted () {
		debugger;
		const me = this;
		const qId = me.qId; // Get question ID
		const activeId = authTokenService.getActiveSurveyId();
		var displayLayouts = utilityService.getDisplayLayouts();
		var surveyTypes = utilityService.getSurveyTypes();
    this.$store.dispatch('loadAllAnswers', { surveyId: activeId, qId: me.qId });
		surveyService.getSurveyType(activeId).then(function (response) {
			if (response && response.data) {
				me.assignDisplayLayout(displayLayouts, me, response.data, surveyTypes);
				// Load metadata for the section
				surveyService.getSectionMetadata(activeId, qId).then(function (response) {
					if (response && response.data) {
						me.section = response.data;
						me.columns = JSON.parse(me.section.columns);
						me.columnHeader = me.section.columnHeader;
						me.answersMatrix = answerService.getAnswerMatrix(qId, me.section.questions, me.columns, me.answer, me.displayLayout, displayLayouts);
						me.answerLayout = {
							matrix: me.answersMatrix,
							answer: me.answer,
							props: answerService.getFieldProps(qId),
							columns: me.columns,
							displayLayouts: displayLayouts
						};
						me.loading = false;
						me.$emit('update-status', { status: 0, id: me.qId });
						if (me.answerLayout.answer !== undefined) {
							me.hasExp = true;
						}	else {
							me.hasExp = false;
						}
					}
				})
				.catch(function (e) {
					console.log(e);
					throw e;
				});
			}
		})
		.catch(function (e) {
			console.log(e);
			console.log('Error loading survey type in questionMixins.js')
			throw e;
		});
	},
	methods: {
		updateAnswer: function (val) {
			debugger;
			if (val.questionId)	{
				this.answer[0][val.questionId][val.answerId] = val.value;
			}	else if (val.questionEntryId || val.questionEntryId == 0)	{
				// Trying to find the property name of the row identifyer, the property name has the letter "id",
				// we skip the first item since that is the table entry id for use as a primary key.
				var idNames = Object.keys(this.answer[0]);
				var found = false;
				var idName = '';
				// If the sections are part of layout I, then we look for orgCod instead
				if (this.displayLayout == this.answerLayout.displayLayouts.I)	{
					idName = "orgCod";
        }	else {
					for (let i = 1; i < idNames.length && !found; i++) {
						if (idNames[i].toLowerCase().includes('id')) {
							idName = idNames[i];
							found = true;
						}
					}
        }
				found = false;
				if (this.displayLayout == this.answerLayout.displayLayouts.H) {
					this.answer = this.answerLayout.answer;
				}

				for (let i = val.approxIndex; i < this.answer.length && !found; i++)
				{
					if (this.answer[i][idName] == val.questionEntryId)
					{
						this.answer[i][val.answerId] = val.value;
						found = true;
					}
				}

				if (!found) {
					console.error("Could not find identifier : '" + val.questionEntryId + "'");
				}
			}	else {
				this.answer[0][val.answerId] = val.value;
			}
		},
		saveAnswer: function (val, expval, expval2, fy1Con, fy1Pla, isStandardSurvey) {
			// Save the entire survey
			var questionId = this.qId;
			if (questionId === "4") {
				this.$store.dispatch('saveQuestion', {
					qId: val, expval: expval, expval2: expval2, fy1Con: this.answerLayout.answer[0].fy1Con, fy1Pla: this.answerLayout.answer[0].fy1Pla, answersOfCountries: this.answerLayout.answer, isStandardSurvey: isStandardSurvey
				});
			} else {
				this.$store.dispatch('saveQuestion', {
					qId: val, expval: expval, expval2: expval2, fy1Con: '', fy1Pla: '', isStandardSurvey: isStandardSurvey
				});
			}
		},
		inputChanged: function (field, evt) {
			debugger;
			console.log("field", field);
			console.log("evt", evt);
			if (evt) {
				// Add commas to the value
				const newVal = evt
					.replace(/\D/g, '')
					.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
				const intValue = parseInt(newVal);
				const fValue = intValue.toLocaleString();
				this.answer[field] = fValue;
			}
		},
		getTotals: function (one, two) {
			debugger;
			const vOne = utilityService.convertStringToNum(one);
			const vTwo = utilityService.convertStringToNum(two);
			return vOne + vTwo;
		},
		assignDisplayLayout: function (displayLayouts, me, surveyType, surveyTypes) {
			// TODO: Add logic for DoD and standard (only standard atm)
			if (surveyType == surveyTypes.Standard) {
				this.$store.dispatch('loadSurveyType', { isStandardSurvey: true });
			}	else if (surveyType == surveyTypes.DOD)	{
				this.$store.dispatch('loadSurveyType', { isStandardSurvey: false });
			}
			switch (surveyType) {
				case surveyTypes.Standard:
					switch (me.qId) {
						case '11':
							me.displayLayout = displayLayouts.A;
							break;
						case '1':
						case '3':
						case '5':
							me.displayLayout = displayLayouts.K;
							break;
						case '7':
						case '10':
							me.displayLayout = displayLayouts.B;
							break;
						case '12':
						case '13':
							me.displayLayout = displayLayouts.N;
							break;
						case '16':
						case '17':
							me.displayLayout = displayLayouts.C;
							break;
						case '6':
						case '15':
							me.displayLayout = displayLayouts.D;
							break;
						case '2':
							me.displayLayout = displayLayouts.E;
							break;
						case '4':
							me.displayLayout = displayLayouts.F;
							break;
						case '8':
						case '9':
							me.displayLayout = displayLayouts.G;
							break;
						case '14':
							me.displayLayout = displayLayouts.H;
							break;
						case '18':
						case '19':
							me.displayLayout = displayLayouts.I;
							break;
						case '20':
							me.displayLayout = displayLayouts.M;
							break;
    }
					break;
				case surveyTypes.DOD:
					switch (me.qId) {
						case '12':
							me.displayLayout = displayLayouts.A;
							break;
						case '1':
						case '3':
						case '5':
							me.displayLayout = displayLayouts.K;
							break;
						case '8':
						case '11':
							me.displayLayout = displayLayouts.B;
							break;
						case '13':
						case '14':
						case '15':
							me.displayLayout = displayLayouts.N;
							break;
						case '18':
						case '19':
							me.displayLayout = displayLayouts.C;
							break;
						case '7':
						case '17':
							me.displayLayout = displayLayouts.D
							break;
						case '2':
							me.displayLayout = displayLayouts.E;
							break;
						case '4':
							me.displayLayout = displayLayouts.F;
							break;
						case '9':
						case '10':
							me.displayLayout = displayLayouts.G;
							break;
						case '16':
							me.displayLayout = displayLayouts.H;
							break;
						case '20':
						case '21':
							me.displayLayout = displayLayouts.I;
							break;
						case '6':
							me.displayLayout = displayLayouts.J;
							break;
					}
        }
		}
	}
};
